export function roleInPortal(user, portalKey) {
  if (!user) return null;
  if (user.global_role === "super_admin") return "super_admin";
  if (user.global_role === "team_member") {
    const scope = user.portal_scope || [];
    if (!scope.length || scope.includes(portalKey)) return "team_member";
  }
  const m = (user.memberships || []).find(
    (x) => x.portal_key === portalKey && (x.status || "active") === "active"
  );
  return m ? m.role : null;
}

export function isManager(user, portalKey) {
  return ["super_admin", "team_member", "portal_admin"].includes(
    roleInPortal(user, portalKey)
  );
}

export function isGlobal(user) {
  return user && ["super_admin", "team_member"].includes(user.global_role);
}

// Portal-configurable role label (falls back to generic i18n key)
export function roleLabel(config, role, L, t) {
  const labels = config?.role_labels || {};
  if (labels[role]) return L(labels[role]);
  return t(`roles.${role}`) || role;
}

// Portal-configurable terminology (e.g. "Anfrage" -> "Projektanfrage", "Kategorie" -> "Gewerk").
// Falls back to the provided generic label when no per-portal term is configured.
export function term(config, key, L, fallback) {
  const o = config?.terms?.[key];
  return o ? L(o) : fallback;
}
